import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b049e26"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner1" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title_left" }, "申請状況一覧")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}
const _hoisted_8 = { class: "" }
const _hoisted_9 = { style: {"width":"100%"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※"),
  /*#__PURE__*/_createTextVNode("申請期間 ")
], -1))
const _hoisted_20 = ["max"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-center" }, "~", -1))
const _hoisted_22 = ["max"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "申請種別", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_25 = ["value"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "ステータス", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { style: {"width":"100%"} }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"3%"} }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"18%"} }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"14%"} }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "キーワード", -1))
const _hoisted_40 = { colspan: "3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "希望納期", -1))
const _hoisted_42 = ["max"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "まで", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "完了しているものを除く", -1))
const _hoisted_45 = { style: {"width":"100%"} }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"16%"} }, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"13%"} }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"15%"} }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"10%"} }, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "エージェント", -1))
const _hoisted_55 = { colspan: "2" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1))
const _hoisted_57 = ["value"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "対応担当者", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "form-control-title" }, "営業担当者", -1))
const _hoisted_60 = { class: "form-control-title" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_62 = { class: "header" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "申請履歴")
], -1))
const _hoisted_64 = { class: "page-size-selector" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "表示件数 ", -1))
const _hoisted_66 = ["onClick"]
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { class: "" }
const _hoisted_69 = {
  key: 0,
  class: ""
}
const _hoisted_70 = {
  key: 1,
  class: ""
}
const _hoisted_71 = {
  class: "table table-bordered",
  style: {"font-size":"11.5px"}
}
const _hoisted_72 = { class: "thead-light" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_btnUpdate" }, "編集", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_SinseiUser" }, "申請者", -1))
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_SinseiTitle" }, "申請タイトル", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_Operater" }, [
  /*#__PURE__*/_createTextVNode("対応"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("担当者")
], -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_KaunetUser" }, [
  /*#__PURE__*/_createTextVNode("営業"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("担当者")
], -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col_AgName" }, [
  /*#__PURE__*/_createTextVNode("申請"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("AG名称")
], -1))
const _hoisted_80 = {
  "data-name": "mBtnUpdate",
  style: {"text-align":"center"}
}
const _hoisted_81 = ["onClick"]
const _hoisted_82 = {
  "data-name": "mShinseiNo",
  class: "form-control-center"
}
const _hoisted_83 = {
  "data-name": "mShinseiDate",
  class: "form-control-center"
}
const _hoisted_84 = { "data-name": "mShinseiUser" }
const _hoisted_85 = { class: "ellipsis-label" }
const _hoisted_86 = { "data-name": "mShinseiCategory" }
const _hoisted_87 = { "data-name": "mShinseiTitle" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = {
  key: 0,
  class: "com_icon_new_app"
}
const _hoisted_90 = { "data-name": "mShinseiStatus" }
const _hoisted_91 = {
  "data-name": "mWishDate",
  class: "form-control-center"
}
const _hoisted_92 = {
  "data-name": "mLastUpdate",
  class: "form-control-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_content_pagination = _resolveComponent("content-pagination")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _hoisted_6,
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17,
              _hoisted_18,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_19,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.appSearchCond.appDateFrom) = $event)),
                      max: _ctx.AppConstants.MAX_DATE_VALUE,
                      class: "form-control"
                    }, null, 8, _hoisted_20), [
                      [_vModelText, _ctx.appSearchCond.appDateFrom]
                    ])
                  ]),
                  _hoisted_21,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.appSearchCond.appDateTo) = $event)),
                      max: _ctx.AppConstants.MAX_DATE_VALUE,
                      class: "form-control"
                    }, null, 8, _hoisted_22), [
                      [_vModelText, _ctx.appSearchCond.appDateTo]
                    ])
                  ]),
                  _hoisted_23,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.appSearchCond.appType) = $event)),
                      class: "form-control"
                    }, [
                      _hoisted_24,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appCategoryList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_25))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.appSearchCond.appType]
                    ])
                  ]),
                  _hoisted_26,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.appSearchCond.status) = $event)),
                      class: "form-control"
                    }, [
                      _hoisted_27,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.text), 9, _hoisted_28))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.appSearchCond.status]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_29, [
              _hoisted_30,
              _hoisted_31,
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_39,
                  _createElementVNode("td", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.appSearchCond.keyword) = $event)),
                      type: "text",
                      placeholder: "申請タイトルと申請内容を検索します",
                      maxlength: "50",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.appSearchCond.keyword]
                    ])
                  ]),
                  _hoisted_41,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.appSearchCond.wishDate) = $event)),
                      max: _ctx.AppConstants.MAX_DATE_VALUE,
                      class: "form-control"
                    }, null, 8, _hoisted_42), [
                      [_vModelText, _ctx.appSearchCond.wishDate]
                    ])
                  ]),
                  _hoisted_43,
                  _hoisted_44,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "form-check-input",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.appSearchCond.disableFinised) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.appSearchCond.disableFinised]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("table", _hoisted_45, [
              _hoisted_46,
              _hoisted_47,
              _hoisted_48,
              _hoisted_49,
              _hoisted_50,
              _hoisted_51,
              _hoisted_52,
              _hoisted_53,
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _hoisted_54,
                  _createElementVNode("td", _hoisted_55, [
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.appSearchCond.agCode) = $event)),
                      class: "form-control"
                    }, [
                      _hoisted_56,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agCodeDataList, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item.value,
                          value: item.value
                        }, _toDisplayString(item.value + " " + item.text), 9, _hoisted_57))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.appSearchCond.agCode]
                    ])
                  ]),
                  _hoisted_58,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.appSearchCond.operater) = $event)),
                      type: "text",
                      maxlength: "20",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.appSearchCond.operater]
                    ])
                  ]),
                  _hoisted_59,
                  _createElementVNode("td", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.appSearchCond.kaunetUser) = $event)),
                      type: "text",
                      maxlength: "20",
                      class: "form-control"
                    }, null, 512), [
                      [_vModelText, _ctx.appSearchCond.kaunetUser]
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_60, [
                    _createElementVNode("button", {
                      type: "button",
                      name: "btnSearch",
                      class: "btn btn-primary",
                      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
                    }, " 検索 ")
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_61,
          _createElementVNode("div", _hoisted_62, [
            _hoisted_63,
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dispNums, (size, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: size }, [
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.changePageSize(size)), ["prevent"]),
                    class: _normalizeClass({ active: _ctx.itemsPerPage === size, disabled: _ctx.isSearchMode })
                  }, _toDisplayString(size) + "件 ", 11, _hoisted_66),
                  (index < _ctx.dispNums.length - 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_67, " | "))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            (!_ctx.isSearchMode)
              ? (_openBlock(), _createElementBlock("label", _hoisted_69, "件数："))
              : _createCommentVNode("", true),
            (!_ctx.isSearchMode)
              ? (_openBlock(), _createElementBlock("label", _hoisted_70, _toDisplayString(_ctx.appDataList.length.toLocaleString()) + " 件 ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_71, [
              _createElementVNode("thead", _hoisted_72, [
                _createElementVNode("tr", null, [
                  _hoisted_73,
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_SinseiNo',
                'sortable',
                _ctx.isDirectionASC('shinseiNo') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSortItem('shinseiNo')))
                  }, " 申請No. ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_SinseiDate',
                'sortable',
                _ctx.isDirectionASC('shinseiDate') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSortItem('shinseiDate')))
                  }, " 申請日 ", 2),
                  _hoisted_74,
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_SinseiCategiry',
                'sortable',
                _ctx.isDirectionASC('shinseiCategory') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSortItem('shinseiCategory')))
                  }, " 申請種別 ", 2),
                  _hoisted_75,
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_SinseiStatus',
                'sortable',
                _ctx.isDirectionASC('shinseiStatus') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.onSortItem('shinseiStatus')))
                  }, " ステータス ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_WishDate',
                'sortable',
                _ctx.isDirectionASC('wishDate') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSortItem('wishDate')))
                  }, " 希望納期 ", 2),
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_LastUpdate',
                'sortable',
                _ctx.isDirectionASC('lastUpdate') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onSortItem('lastUpdate')))
                  }, " 最終更新日 ", 2),
                  _hoisted_76,
                  _hoisted_77,
                  _createElementVNode("th", {
                    class: _normalizeClass([
                'col_AgCode',
                'sortable',
                _ctx.isDirectionASC('agCode') ? 'asc' : 'desc',
              ]),
                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onSortItem('agCode')))
                  }, [
                    _createTextVNode(" 申請"),
                    _hoisted_78,
                    _createTextVNode("AGコード ")
                  ], 2),
                  _hoisted_79
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedData, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.applicationNo
                  }, [
                    _createElementVNode("td", _hoisted_80, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "mBtnUpdate",
                        class: "btn btn-primary btn-sm",
                        onClick: ($event: any) => (_ctx.onEdit(item.applicationNo))
                      }, " 編集 ", 8, _hoisted_81)
                    ]),
                    _createElementVNode("td", _hoisted_82, _toDisplayString(item.applicationNo), 1),
                    _createElementVNode("td", _hoisted_83, _toDisplayString(item.applicationDate), 1),
                    _createElementVNode("td", _hoisted_84, [
                      _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_85, [
                        _createTextVNode(_toDisplayString(item.applicationUser), 1)
                      ])), [
                        [_directive_tooltip, item.applicationUser]
                      ])
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_86, [
                      _createTextVNode(_toDisplayString(item.applicationCategoryName), 1)
                    ])), [
                      [_directive_tooltip, item.applicationCategoryName]
                    ]),
                    _createElementVNode("td", _hoisted_87, [
                      _withDirectives((_openBlock(), _createElementBlock("span", {
                        class: "ellipsis-link",
                        onClick: ($event: any) => (_ctx.onEdit(item.applicationNo, true))
                      }, [
                        _createTextVNode(_toDisplayString(item.applicationTitle), 1)
                      ], 8, _hoisted_88)), [
                        [_directive_tooltip, item.applicationTitle]
                      ]),
                      (item.kaunetNewFlg)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_89, " NEW"))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("td", _hoisted_90, [
                      _createTextVNode(_toDisplayString(item.statusName), 1)
                    ])), [
                      [_directive_tooltip, item.statusName]
                    ]),
                    _createElementVNode("td", _hoisted_91, _toDisplayString(item.wishDate), 1),
                    _createElementVNode("td", _hoisted_92, _toDisplayString(item.lastUpdDate), 1),
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(item.operater), 1)
                      ])), [
                        [_directive_tooltip, item.operater]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(item.kaunetUser), 1)
                      ])), [
                        [_directive_tooltip, item.kaunetUser]
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", null, _toDisplayString(item.appAgCode), 1)
                    ]),
                    _createElementVNode("td", null, [
                      _withDirectives((_openBlock(), _createElementBlock("span", null, [
                        _createTextVNode(_toDisplayString(item.appAgName), 1)
                      ])), [
                        [_directive_tooltip, item.appAgName]
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createVNode(_component_content_pagination, {
              "current-page": _ctx.currentPage,
              "total-pages": _ctx.totalPages,
              "items-per-page": _ctx.itemsPerPage,
              onPageChanged: _ctx.handlePageChange
            }, null, 8, ["current-page", "total-pages", "items-per-page", "onPageChanged"])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}